import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef, OnInit, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '../shared/services/globals.service';
import { BaseDQOIComponent } from '../shared/base-components/base-dqoi.component';
import { OrderBus } from '../shared/models/OrderBus';
import { OrderService } from '../shared/services/order.service';
import { DQOIService } from '../shared/services/DQOI.service';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { AdditionalOrderData } from '../shared/models/AdditionalOrderData';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonFunctions } from '../shared/static/common-functions';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { GItem } from '../shared/models/GItem';
import { Address } from '../shared/models/Address';
import { CustomerService } from '../shared/services/customer.service';
import { OrderPage } from '../shared/models/OrderPage';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { GroupResult, groupBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { DQOIItem } from '../shared/models/DQOIItem';
import { DateFunctions } from '../shared/static/date-functions';
import { OrderMessageInfo } from '../shared/models/OrderMessageInfo';
import { GeographyInfoBus } from '../shared/models/GeographyInfoBus';
import { CommonValues } from '../shared/static/CommonValues';
import { SupplierInfoComponent } from '../shared/contact/supplier-info/supplier-info.component';
import { WindowContents } from '../shared/enums/windowContents';
import { ReceivingComponent } from './modal/receiving/receiving.component';
import { VendorCreditsComponent } from './modal/vendor-credits/vendor-credits.component';
import { VendorReturnsComponent } from '../inventory/vendor-returns/vendor-returns.component';
import { SaveMode } from '../shared/enums/SaveMode';
import { DQOIParam } from '../shared/models/DQOIParam';
import { OrderLineItemsComponent } from './order-lineitems/order-lineitems.component';
import { OrderAttachmentsComponent } from './order-attachments/order-attachments.component';
import { OrderErrorsComponent } from './order-errors/order-errors.component';
import { OrderDetailsBus } from '../shared/models/OrderDetailsBus';
import { OrderSaveParam } from '../shared/models/OrderSaveParam';
import { CDocument } from '../shared/models/CDocument';
import { BaseMessageInfo } from '../shared/models/BaseMessageInfo';
import { SubPOOrderInfo } from '../shared/models/SubPOOrderInfo';
import { v_LocationDetailBus } from '../shared/models/v_LocationDetailBus';
import { CommonParam } from '../shared/models/CommonParam';
import { DispatchOrder } from '../shared/models/DispatchOrder';
import { v_SupplierLocationBus } from '../shared/models/v_SupplierLocation';
import { OrderSecurity } from '../shared/security/order-security';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';
import { OrderBillsComponent } from './order-bills/order-bills.component';
import { ConstructionService } from '../shared/services/construction.service';
import { RefreshToken } from '../shared/models/RefreshToken';
import { MessageInfo } from '../shared/models/MessageInfo';
import { SearchOperatingMode } from '../shared/enums/SearchOperatingMode';
import { v_OrderDispatchBus } from '../shared/models/v_OrderDispatchBus';
import { OrderNotesComponent } from './notes/order-notes.component';
import { MessageType } from '../shared/enums/MessageType';
import { DQOIMessage } from '../shared/models/DQOIMessage';
import { Email } from '../shared/models/Email';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { ICPLoader, UseCPLoader } from '../shared/decorators/cploader/cploader-decorator';
import { IFeatureFlagSet, UseFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { PrintService } from '../shared/services/print.service';
import { Message } from '../shared/models/message';
import { PdfResponse } from '../shared/models/PdfResponse';
import { DQOIOrderDisplaySettings } from '../shared/models/DQOIDisplaySettings';
import { InventoryService } from '../shared/services/inventory.service';
import { ShipToLocationsBus } from '../shared/models/ShipToLocationsBus';

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrdersComponent extends BaseDQOIComponent<OrderBus, OrderService, AdditionalOrderData, OrderPage> implements OnInit, AfterViewInit, OnDestroy {

    compLoader: ICPLoader = this as any;
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    billToAddress: Address = new Address();
    orders: GItem[] = [];
    appCode: string = "Order";
    iseNbrText: string = "ISE #";
    count: number;
    orderDispatch: v_OrderDispatchBus
    popUp: boolean = false;
    errorMsg: string;
    shipToLocations: ShipToLocationsBus[];
    shipToLocationsDDL: GItem[];
    selectedBranch: any;
    @ViewChild('supplierInfoComp') protected supplierInfoComp: SupplierInfoComponent;
    @ViewChild('receivingComponent') protected receivingComponent: ReceivingComponent;
    @ViewChild('orderBills') protected billsComponent: OrderBillsComponent;
    @ViewChild('vendorCreditsComponent') protected vendorCreditsComponent: VendorCreditsComponent;
    @ViewChild('vendorReturnsComponent') protected vendorReturnsComponent: VendorReturnsComponent;
    @ViewChild("LineItems") lineItemsComp: OrderLineItemsComponent;
    @ViewChild("Attachments") attachmentsComp: OrderAttachmentsComponent;
    @ViewChild("Notes") orderNotesComp: OrderNotesComponent;
    @ViewChild("Errors") errorsComp: OrderErrorsComponent;
    @ViewChild("dateExpected") dateExpected: DatePickerComponent;
    @ViewChild("dateRequested") dateRequested: DatePickerComponent;
    supplierId_Zuggit: string = CommonValues.Supplier_Zuggit;
    @Input() dqoiOrderDisplaySettings: DQOIOrderDisplaySettings = new DQOIOrderDisplaySettings();
    public min = 1;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, qry_rd: DQOIReferenceDataQuery, svc_data: OrderService, private svc_customer: CustomerService, private cd: ChangeDetectorRef, private svc_construction: ConstructionService, private printService: PrintService, private svc_inventory: InventoryService) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.addtlDataClass = "AdditionalOrderData";
        this.searchTarget = SearchTarget.order;
        this.pageData = new OrderPage(svc_data);
        this.saveMode = SaveMode.all;
        this.common = new CommonParam;
        this.setupCheckForm();
    }
    reduceToMinData() { }
    refreshSubs: Subscription;
    refreshByTrigger(token: RefreshToken) {

        if (token.all) {
            this.getData();
        }
    }
    override ngOnInit() {
        super.ngOnInit();
        this.customStatusRules = _.cloneDeep(this.referenceData.orderStatus);
        if(this.compFeatureFlagSet.featureFlagSet['ui-enable-order-ship-to-location-dropdown']){
            this.svc_customer.getShipToLocations().subscribe(data => {
                if(!data.hasErrors) {
                    this.shipToLocations = data.result;
                    this.shipToLocationsDDL = this.shipToLocations.map(x => new GItem({ "description": x.locationName, "value": x.locationId, "category": "", "reference": null }));
                }
            });
        }
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.svc_construction) {
            this.refreshSubs = this.svc_construction.refreshSubject.subscribe((token: RefreshToken) => {
                this.refreshByTrigger(token);
            });
        }
        if (this.globals.user.isZuggitUser) {
            this.iseNbrText ="Cust PO #"
        }
        
    }

    cancelChildren() {
        super.cancelChildren();
        if (!this.hasData || this.hasData && !CommonFunctions.hasValue(this.data.supplierLocation)) {
            this.supplierInfoComp.clear();
        }
        this.selectedBranch = undefined;
    }
    customStatusRules: GItem[];
    get hasCustomStatusRules(): boolean {
        return CommonFunctions.hasArrayElementValue(this.customStatusRules);
    }
    setOrderStatusRules() {

        if (this.hasCustomStatusRules && this.globals.personId === this.data.buyerPersonId) {
            var index = this.customStatusRules.map(s => s.value).indexOf('fa457c0e-d19a-458a-be69-2c4f0adabfd6');
            this.customStatusRules[index].canSelect = true;
        }
    }
    /* Brians - can restructure as see fit. */
    public activeChildComp: number;
    public showWindow: boolean = false;
    public contentTypes = WindowContents;
    public orderSecurity: OrderSecurity = new OrderSecurity("", this.rights);
    popWindow(injected: number) {
        switch (injected) {
            case 3:
                this.doReceiving();
                break;
            default:
                this.activeChildComp = injected;
                this.showWindow = true;
                break;
        }
    }
    onClosed(e) {
        switch (e) {
            default:
                this.showWindow = false;
        }
    }

    /* End Brians - can restructer as see fit. */

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'orderId': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'supplierId': new UntypedFormControl('', Validators.required),
        'supplierLocationId': new UntypedFormControl('', Validators.required),
        'customerId': new UntypedFormControl('', Validators.required),
        'locationId': new UntypedFormControl('', Validators.required),
        'buyerPersonId': new UntypedFormControl('', Validators.required),
        'shippingGeographyId': new UntypedFormControl(),
        'shippingMethodId': new UntypedFormControl('', Validators.required),
        'isOrderPlaced': new UntypedFormControl(),
        'isOrderBilled': new UntypedFormControl(),
        'isOrderComplete': new UntypedFormControl(),
        'orderNumber': new UntypedFormControl(),
        'dateEntered': new UntypedFormControl('', Validators.required),
        'dateRequested': new UntypedFormControl(),
        'dateExpected': new UntypedFormControl(''),
        'notes': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'termId': new UntypedFormControl(),
        'ccaccountId': new UntypedFormControl(),
        'isLocked': new UntypedFormControl(),
        'approverUserId': new UntypedFormControl(),
        'approvedDate': new UntypedFormControl(),
        'employeeOrderPersonId': new UntypedFormControl(),
        'empExpenseValidated': new UntypedFormControl(),
        'returnTrackNbr': new UntypedFormControl(),
        'returnVendTrackNbr': new UntypedFormControl(),
        'returnUserId': new UntypedFormControl(),
        'returnDt': new UntypedFormControl(),
        'isenbr': new UntypedFormControl(),
        'refNbr': new UntypedFormControl(),
        'acctMgr': new UntypedFormControl(),
        'regionName': new UntypedFormControl(),
        'limit': new UntypedFormControl(),
        'requestedById': new UntypedFormControl(),
        'orderStatusId': new UntypedFormControl('', Validators.required),
        'blanketAmount': new UntypedFormControl(),
        'projMgrPersonId': new UntypedFormControl(),
        'chgOrdBlanketAmount': new UntypedFormControl(),
        'approvedUserId': new UntypedFormControl(),
        'approvedDt': new UntypedFormControl(),
        'remBlanketAmount': new UntypedFormControl(),
        'remBudget': new UntypedFormControl(),
        'markUp': new UntypedFormControl(),
        'margin': new UntypedFormControl()
    });
    setForm() {
        this.editForm.patchValue({
            orderId: this.data.orderId,
            companyId: this.data.companyId,
            supplierId: this.data.supplierId,
            supplierLocationId: this.data.supplierLocationId,
            customerId: this.data.customerId,
            locationId: this.data.locationId,
            buyerPersonId: this.data.buyerPersonId,
            shippingGeographyId: this.data.shippingGeographyId,
            shippingMethodId: this.data.shippingMethodId,
            isOrderPlaced: this.data.isOrderPlaced,
            isOrderBilled: this.data.isOrderBilled,
            isOrderComplete: this.data.isOrderComplete,
            orderNumber: this.data.orderNumber ?? '',
            dateEntered: this.data.dateEntered,
            dateRequested: this.data.dateRequested,
            dateExpected: this.data.dateExpected,
            notes: this.data.notes,
            insertUserId: this.data.insertUserId,
            insertDt: this.data.insertDt,
            updateUserId: this.data.updateUserId,
            updateDt: this.data.updateDt,
            termId: this.data.termId,
            ccaccountId: this.data.ccaccountId,
            isLocked: this.data.isLocked,
            approverUserId: this.data.approverUserId,
            approvedDate: this.data.approvedDate,
            employeeOrderPersonId: this.data.employeeOrderPersonId,
            empExpenseValidated: this.data.empExpenseValidated,
            returnTrackNbr: this.data.returnTrackNbr,
            returnVendTrackNbr: this.data.returnVendTrackNbr,
            returnUserId: this.data.returnUserId,
            returnDt: this.data.returnDt,
            isenbr: this.data.isenbr,
            refNbr: this.data.refNbr,
            requestedById: this.data.requestedById,
            orderStatusId: this.data.orderStatusId,
            blanketAmount: this.data.blanketAmount,
            projMgrPersonId: this.data.projMgrPersonId,
            chgOrdBlanketAmount: this.data.chgOrdBlanketAmount,
            approvedUserId: this.data.approvedUserId,
            approvedDt: this.data.approvedDt
        });
        this.markUp = null;
        if (this.data && this.data.supplierLocation && this.data.supplierLocation.markUp) {
            this.markUp = this.data.supplierLocation.markUp;
        }
        this.margin = null;
        if (this.data && this.data.supplierLocation && this.data.supplierLocation.margin) {
            this.margin = this.data.supplierLocation.margin;
        }
        this.orderSecurity = new OrderSecurity(this.data.orderStatusId, this.rights);
        if (this.dateExpected) {
            this.dateExpected.readonly = (this.readOnly || !this.orderSecurity.dateExpected);
        }
        if (this.dateRequested) {
            this.dateRequested.readonly = (this.readOnly || !this.orderSecurity.dateRequested);
        }
        this.setOrderStatusRules();
        if (this.lineItemsComp) {
            this.lineItemsComp.statusChange(this.data.orderStatusId);
            this.lineItemsComp.setSupplier(this.data.supplierId);
        }
    }
    setFormAddtl() {
        this.editForm.patchValue({
            acctMgr: this.addtlData.acctMgr,
            regionName: this.addtlData.regionName,
            limit: this.addtlData.poLimit,
            remBudget: this.data.blanketAmount - this.addtlData.amountDue
        });

    }
    setFormLocation(data: v_LocationDetailBus) {
        this.editForm.patchValue({

        });
    }
    isSubPO: boolean = false;
    supplierRequired: boolean = true;

    get requireDispatchJobOnLine(): boolean {
        return this.hasCustomer && (this.customerId.toLowerCase() === CommonValues.CustomerId_ClimatePros || this.customerId.toLowerCase() === CommonValues.CustomerId_ClimateProsLLC)? false : true;
    }
    get readOnlyDateRequested(): boolean {
        return (this.readOnly || !this.orderSecurity.dateRequested)
    }

    get primaryNumber(): string {
        return this.hasData && this.data.orderNumber ? this.data.orderNumber : "";
    }
    get hasStatus(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.orderStatusId);
    }
    get hasBuyer(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.buyerPersonId);
    }
    get hasDateEntered(): boolean {
        return this.hasEditForm && DateFunctions.isValidDate(this.editForm.value.dateEntered);
    }
    get canEditDateEntered(): boolean {
        return this.hasId && !this.isAdded ? false : true;
    }
    get hasDateExpected(): boolean {
        return this.hasEditForm && DateFunctions.isValidDate(this.editForm.value.dateExpected);
    }
    get hasTerm(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.termId);
    }
    get hasProjMgrPerson(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.projMgrPersonId);
    }
    get hasSupplierLocation(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.supplierId) && CommonFunctions.hasGuidValue(this.editForm.value.supplierLocationId);
    }
    get hasLineItem(): boolean {
        return this.hasEditForm && this.lineItemsComp && this.lineItemsComp.hasCount;
    }

    get canDoReceiving(): boolean {
        let okStatus: boolean = false;
        if (this.hasData) {
            okStatus = this.data.orderStatusId != CommonValues.Order_Canceled;
        }
        return this.rights.ReceiveParts && this.serviceMode !== "1" && okStatus;
    }
    billsDisabled: boolean = false;
    get canDoVendorCredits(): boolean {
        return this.serviceMode !== "1";
    }
    get canDoVendorReturns(): boolean {
        return this.serviceMode !== "1";
    }
    get hasShippingMethod(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.shippingMethodId);
    }

    get originalRequired(): boolean {
        if (this.data && this.data.orderStatusId != CommonValues.Order_Canceled && this.isConstruction && this.isSubPO) {
            return true;
        }
        else {
            this.min = 0;
            return false;
        }
    }

    customFormValidation() {
        //dateentered/dateexpected/term
        let okToSave = false;
        if (this.isSubPO) {
            okToSave = (this.hasProjMgrPerson || !this.isConstruction) && this.hasSupplierLocation && (this.originalRequired ? this.editForm.value.blanketAmount >= 1 : true);
        }
        else {
            //[GRG-20210205] removed date expected per const sheet request after defaulting to today
            okToSave = this.hasDateEntered && this.hasTerm && this.hasSupplierLocation && this.hasShippingMethod;
        }
        this.lineItemsComp.sameDispatchId();
        return okToSave;
    }
    setNewDefaults() {
        super.setNewDefaults();
        this.data.isSub = this.isSubPO;
        if (this.isConstruction) {
            this.data.dateExpected = DateFunctions.getDateNow();
        }
    }
    protected setCommon(dqoiItem: DQOIItem) {

        if (this.isConstruction && this.searchOperatingMode != 2) {
            if (dqoiItem.hasJobId) {
                this.common.addParam("DispatchId", dqoiItem.jobId);
                this.common.addParam("DispatchNumber", dqoiItem.jobNumber);
                this.common.addParam("DispatchAccountClassId", dqoiItem.dispatchAccountClassId);
            }
        }
        else {
            if (dqoiItem.hasDispatchId) {
                this.common.addParam("DispatchId", dqoiItem.dispatchId);
                this.common.addParam("DispatchNumber", dqoiItem.dispatchNumber);
                this.common.addParam("DispatchAccountClassId", dqoiItem.dispatchAccountClassId);
            }
        }
    }
    protected resetData(dqoiItem: DQOIItem, callNew: boolean = false) {
        super.resetData(dqoiItem, callNew);
        if (dqoiItem.hasDispatchId) {
            this.getIdsFromDispatchId(dqoiItem.dispatchId);
            this._masterId = dqoiItem.dispatchId;
            this.getListFromMaster();
            this.setCommon(dqoiItem);
            if (dqoiItem.hasOrderId && CommonFunctions.hasGuidValue(dqoiItem.orderId)) {
                this.id = dqoiItem.orderId;
                this.count = dqoiItem.orderCount;
                this.getDataFromId(this.id);
            }
        }
        else {
            this.checkOrdersCBOData(dqoiItem.orderNumber, dqoiItem.orderId);
        }
    }

    itemDisabled(itemArgs: { dataItem: any, index: any }) {
        return !itemArgs.dataItem.canSelect;
    }
    checkOrdersCBOData(orderNumber: string, orderId: any) {
        if (!CommonFunctions.hasArrayElementValue(this.pDataArr)) {
            let item: GItem = { description: orderNumber, value: orderId, category: null, "reference": null };
            this.pDataArr = [];
            this.pDataArr.push(item);
        }
    }
    setDQOIState() {
        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            if (!this.settingFromDQOIState) {
                item.customerId = this.data.customerId;
                item.locationId = this.data.locationId;
            }
            this.setCommon(item);
            this.svc_dqoi.setDQOIItem(item);
            this.settingFromDQOIState = false;;
        }
    }
    email() {
        this.mainLoadingOn(false, this.compLoader);
        this.svc_data.getEmailForOrder(this.id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let email: Email = new Email(info.primaryReturn);
                window.location.assign("mailto: ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
            }
            else {
                this.saveError("Error Trying to Construct Email: " + info.message);
            }
            this.mainLoadingOff(false, this.compLoader);
        });

    }

    getAddtlData() {
        if (this.hasId) {
            this.addtlDataLoader = true;
            this.cd.detectChanges();
            if (this.hasId && !CommonFunctions.hasGuidValue(this.id)) {
                this.id = this.data.orderId;
            }
            if (CommonFunctions.hasGuidValue(this.id)) {
                this.pageData.getNotes(this.id);
            }
            CommonFunctions.unsubscribe(this.subs_dataAddInfo);
            this.subs_dataAddInfo = this.svc_data.getAdditionalData(this.id).subscribe(data => {
                this.addtlData = new AdditionalOrderData(data);
                if (!this.hasMasterId) {

                    if (this.addtlData && this.addtlData.lineItems.length > 0) {
                        this._masterId = this.addtlData.lineItems[0].dispatchId;
                        this.getListFromMaster(true);
                    }
                } else {this.getListFromMaster(true); }
                
                this.orderDispatch = data.dispatchData;
           
                this.setFormAddtl();
                this.addtlDataLoader = false;
                this.getDefaultReturnInv();
                this.cd.detectChanges();
            });
        }
    }

    setForSave(): OrderBus {
        let busObj: OrderBus = new OrderBus(this.data);
        busObj.setFromForm(this.editForm.value);
        if (!this.isSubPO) {
            busObj.shippingGeographyInfo = this.shippingGeoInfoComp.getData();
        }
        busObj.supplierId = this.supplierInfoComp.getData().supplierId;
        busObj.supplierLocationId = this.supplierInfoComp.getData().supplierLocationId;
        let now: Date = DateFunctions.getDateNow();
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.setBeforeSave();
        return busObj;
    }

    saveIndividual() {
        let busObj: OrderBus = this.setForSave();
        CommonFunctions.unsubscribe(this.subs_save);
        this.subs_save = this.svc_data.savePrimary(busObj).subscribe((data: OrderMessageInfo) => {
            if (!data.saveError) {
                this.data = _.cloneDeep(data.orderBus);
                this.originalData = _.cloneDeep(this.data);
                this.saveSuccess();
            }
            else {
                this.saveError(data.message);
            }
        });
        this.readOnly = true;
    }
    getData() {
        super.getData();
    }
    subs_getIdsFromDispatchId: Subscription;
    getIdsFromDispatchId(id: string) {
        CommonFunctions.unsubscribe(this.subs_getIdsFromDispatchId);
        this.subs_getIdsFromDispatchId = this.svc_data.getOrdersForDispatch(id).subscribe((data: GItem[]) => {
            if (data !== null) {
                this.pDataArr = data;
            }
        });
    }
    getDataFromId(id: string) {
        this.id = id;
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.getFromId(id).subscribe((data: OrderBus) => {
            if (data !== null) {
                this.setData(data);
                this.getData();

                //prevent billing if the order status is not partially or fully received
                this.billsDisabled = this.data.orderStatusId != CommonValues.Order_Fully_Received && this.data.orderStatusId != CommonValues.Order_Partially_Received;
                if (this.globals.user.isZuggitUser) {
                    this.billsDisabled =  this.data.orderStatusId == CommonValues.Order_Canceled;
                }
            }
            this.mainLoadingOff(true, this.compLoader);
        });
    }
    getDataFromNumber(number: string) {
        this.mainLoadingOn(true, this.compLoader);
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.getFromNumber(number).subscribe((data: OrderBus) => {
            if (data !== null) {
                this.id = data.orderId;
                this.setData(data);
                this.getData();
            }
            this.mainLoadingOff(true, this.compLoader);
        });
    }
    orderCBOChanged(e: GItem) {
        this.getDataFromId(e.value);

    }
    statusCBOChanged(e: GItem) {
        if (e.value == CommonValues.Order_Fully_Received && this.lineItemsComp) {
            var unReceived = this.lineItemsComp.notFullyReceived();
            if (unReceived) {
                var msg: string = "You cannot set the status to fully received since it has not received all items.";
                this.cnfShowSomeGeneralMessage(msg, "Status Change Error");
                this.editForm.patchValue({
                    orderStatusId: this.originalData.orderStatusId
                });
                return;
            }
        }
        this.orderSecurity = new OrderSecurity(e.value, this.rights);
        this.data.orderStatusId = e.value;
        this.lineItemsComp.statusChange(e.value);
        this.dateExpected.readonly = (this.readOnly || !this.orderSecurity.dateExpected);
        this.dateRequested.readonly = (this.readOnly || !this.orderSecurity.dateRequested);
    }
    createNew(busObj: OrderBus) {
        return new OrderBus(busObj);
    }
    result: any;
    afterDataSet() {
        this.isSubPO = this.data.isSub;
        if (this.hasId) {
            this.holdCusLocDefaults = true;
        }
        this.customerChanged(this.data.customerId, this.holdCusLocDefaults);
        if (this.hasId) {
            this.setShippingGeoInfo(this.data.shippingGeographyInfo);
            this.getLocationInfo(this.data.locationId);
        }
        else {
            this.locationChanged(this.data.locationId);
        }
        this.checkOrdersCBOData(this.data.orderNumber, this.data.orderId);
        if (this.hasId && !this.isAdded) {
            this.refreshDQOIItem(this.id);
        }
        this.setFormSubPOValidation();
    }
    getLocationInfo(id: any) {
        this.svc_dqoi.getLocationDetailAsDefaults(id).subscribe((data: v_LocationDetailBus) => {
            let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            locGeoInfo.set(data.geographyId, data.locationName, data.addressLine1, data.addressLine2, data.city, data.stateProvince, data.countryCd, data.county, data.postalCode);
            this.setLocationGeoInfo(locGeoInfo);
            this.locationDetail = new v_LocationDetailBus(data);
        });
    }

    billToChanged(e: GItem) {
        CommonFunctions.unsubscribe(this.subs_geographyAddressBillTo);
        this.subs_geographyAddressBillTo = this.svc_customer.getGeographyAddress(e.value).subscribe((data: Address) => {
            this.billToAddress = new Address(data);
            this.billToAddress.locationName = e.description;
        });
    }
    panelExpand(e: any) {

    }
    onTabSelect(e: SelectEvent) {
        if (e.title === 'Attachments' && !this.pageData.hasAttachments) {
            this.pageData.getAttachments(this.data.orderId);
        }
        else if (e.title === 'Status History' && !this.pageData.hasStatusHistory) {
            this.pageData.getStatusHistory(this.data.orderId);
        }
        else if (e.title === 'Opportunity' && !this.pageData.hasErrors) {
            this.pageData.getErrors(this.data.orderId);
        }

    }

    delete() {
        if (this.data.isAdded) {
            this.clear();
        }
        else {
            CommonFunctions.unsubscribe(this.subs_delete);
            this.subs_delete = this.svc_data.deleteOrder(this.id, this.data.orderNumber).subscribe((info: OrderMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess();
                    this.clear();
                }
                else {
                    this.deleteError(info.message)
                }
            });
        }
    }
    get canDelete(): boolean {
        return (this.hasId || (this.hasData && this.data.isAdded)) && this.rights.DeleteOrder && this.serviceMode !== "1";
    }
    get dirtyNotes() {
        var rValue = false;
        if (this.data && this.data.hasId && this.editForm && this.editForm.controls["notes"] && this.editForm.controls["notes"].dirty) {
            rValue = true;
        }
        return rValue;

    }
    get canEdit(): boolean {
        let can: boolean = false;

        if (this.hasId || (this.hasData && this.data.isAdded)) {
            //if (this.data.orderStatusId == CommonValues.Order_Completed) {
            if (this.originalData.orderStatusId == CommonValues.Order_Completed) {
                if (this.rights.EditCompletedOrder) {
                    can = true;
                }
            }
            else if (this.originalData.orderStatusId == CommonValues.Order_Fully_Received) {
                if (this.rights.EditFullyReceivedOrder) {
                    can = true;
                }
            }
            else if (this.rights.MaintianOrders || this.rights.EnterBills || this.rights.EditCompletedOrder) {
                can = true;
            }
            can = can && this.serviceMode !== "1";
        }
        if (!this.rights.EditClosedDispatchOrder && this.orderDispatch && (this.orderDispatch.dispatchStatusId == CommonValues.Dispatch_Closed || this.orderDispatch.dispatchStatusId == CommonValues.Dispatch_Billed)) {
            can = false;
        }

        return can;
    }

    shipToCode: string = '';
    isShipToRequestor: boolean;
    isShipToOffice: boolean;
    shipTo() {
        if (this.isShipToRequestor) {
            let requestedById: any = this.isShipToRequestor ? this.editForm.value.requestedById : CommonValues.Guid_Empty;
            CommonFunctions.unsubscribe(this.subs_geographyAddressShipTo);
            this.subs_geographyAddressShipTo = this.svc_data.getOrderShippingAddress(requestedById).subscribe((data: GeographyInfoBus) => {
                this.setShippingGeoInfo(data);
            });
        }
        if (this.isShipToOffice && !this.compFeatureFlagSet.featureFlagSet["ui-enable-order-ship-to-location-dropdown"]) {

            let officeAddress = new GeographyInfoBus();

            officeAddress.set(
                null,
                this.globals.companyAddress[0].locationName,
                this.globals.companyAddress[0].addressLine1,
                this.globals.companyAddress[0].addressLine2,
                this.globals.companyAddress[0].city,
                this.globals.companyAddress[0].stateProvince,
                null,
                null,
                this.globals.companyAddress[0].postalCode,
                null
            );

            this.setShippingGeoInfo(officeAddress);
        }        
        else {
            this.setShippingGeoInfo(this.data.shippingGeographyInfo);
        }
    }

    shipToOfficeChanged(locationId: any) {
        if (locationId && this.shipToLocations) {
            let branchAddress = new GeographyInfoBus();
            let branchData = this.shipToLocations.find(x => x.locationId == locationId.value);
            if(branchData) {
                branchAddress.set(
                    null,
                    "Climate Pros",
                    branchData.address1,
                    branchData.address2,
                    branchData.city,
                    branchData.stateProvince,
                    null,
                    null,
                    branchData.postal,
                    null
                );

                this.setShippingGeoInfo(branchAddress);            
                this.editForm.markAsDirty();
            }
        }
    }

    shipToRequestor(e: boolean) {
        if (e) {
            this.isShipToRequestor = true;
            this.isShipToOffice = false;
        } else {
            this.isShipToRequestor = false;
        }
        this.sendParentMessageChange(MessageType.changed);
        this.shipTo();
    }
    //to be removed when ui-enable-order-ship-to-location-dropdown flag is retired
    shipToOffice(e: boolean) {
        if (e) {
            this.isShipToOffice = true;
            this.isShipToRequestor = false;
        } else {
            this.isShipToOffice = false;
        }
        this.sendParentMessageChange(MessageType.changed);
        this.shipTo();
    }
    sendParentMessageChange(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        let msg: DQOIMessage = new DQOIMessage();
        msg.messageType = type;
        this.dqoiMessage.emit(msg);

    }
    createInvoiceFromBill($event) {

        this.sendParentMessageToCreateInvoiceFromOrderBill($event);

    }
    createSupplierCreditFromBill($event) {
        this.doVendorCredits($event);
    }
    sendParentMessageToCreateInvoiceFromOrderBill(orderBillId: string) {
        let msg: DQOIMessage = new DQOIMessage();
        msg.messageType = MessageType.createInvoiceFromOrderBill;
        msg.messageData = orderBillId;
        this.dqoiMessage.emit(msg);

    }
    goToInvoice(invoiceId: string) {
        let msg: DQOIMessage = new DQOIMessage();
        msg.messageData = invoiceId;
        msg.messageType = MessageType.gotoInvoice;
        this.dqoiMessage.emit(msg);
  

    }
    closeWindow(code: string) {
        switch (code.toUpperCase()) {
            case "RECEIVING":
                if (!this.lineItemsComp.isDirty) {
                    this.getAddtlData();
                }
                this.receivingActive = false;
                break;
        }
    }
    doReceiving() {
        this.receivingActive = true;
        this.receivingComponent.setup(this.id);
    }
    receivingActive: boolean = false;
    receivingClosed(e: any) {
        if (!this.lineItemsComp.isDirty) {
            this.getAddtlData();
        }
        this.receivingActive = false;
        this.lineItemsComp.rebindGridData();
    }
    doBills() {
        this.billsActive = true; 1
        this.billsComponent.setup(this.id);
    }
    billsActive: boolean = false;
    billsClosed(e: any) {
        this.billsActive = false;
        this.getAddtlData();
    }
    doVendorCredits(orderBillId:any) {
        this.vendorCreditsActive = true;
        this.vendorCreditsComponent.setup(this.id, orderBillId); //this.addtlData.lineItems);
    }
    vendorCreditsActive: boolean = false;
    vendorCreditsClosed(e: any) {
        this.vendorCreditsActive = false;
    }
    doVendorReturns() {
        this.defaultReturnsInv = [];
        this.defaultReturnsInv = this.getDefaultReturnInv();
        this.vendorReturnsActive = true;
        //this.getData();
        this.vendorReturnsComponent.setup(this.id);
        this.vendorReturnsComponent.defaultInventory = this.defaultReturnsInv;
        this.vendorReturnsComponent.setDefaultInvFromVendorReturn(this.id);
        this.vendorReturnsComponent.setFormDefaults();
    }
    vendorReturnsActive: boolean = false;
    vendorReturnsClosed(e: any) {
        this.vendorReturnsActive = false;
    }
    defaultReturnsInv: OrderDetailsBus[] = [];
    getDefaultReturnInv() {
        return this.addtlData ? this.addtlData.lineItems.filter(s => s.toBeReturned == true) : [];
    }
    print() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_print);
        if (this.compFeatureFlagSet.featureFlagSet["ui-enable-new-order-printing"]) {
            this.subs_print = this.svc_data.printUsingIronPdf(this.id).subscribe((data: PdfResponse) => {
                if (CommonFunctions.hasValue(data) && !data.hasErrors) {
                    this.printService.printIronPdf(data, "Order-" + this.data.orderNumber + ".pdf");
                }
                else {
                    this.notifyError("- A pdf of Order " + this.data.orderNumber + " could not be generated.");
                }
                this.compLoader.cpLoaderOff();
            },
                (error) => {
                    this.handleError(error);
                });
        }
        else {
            this.subs_print = this.svc_data.print(this.id).subscribe((data: CDocument) => {
                this.printService.printPdf(data);
                this.compLoader.cpLoaderOff();
            });
        }
    }
    printZuggit() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_print);
            this.subs_print = this.svc_data.printUsingIronPdfZuggit(this.id).subscribe((data: PdfResponse) => {
                if (CommonFunctions.hasValue(data) && !data.hasErrors) {
                    this.printService.printIronPdf(data, "OrderZuggit-" + this.data.orderNumber + ".pdf");
                }
                else {
                    this.notifyError("- A pdf of Order " + this.data.orderNumber + " could not be generated.");
                }
                this.compLoader.cpLoaderOff();
            },
                (error) => {
                    this.handleError(error);
                });

    }

    setup(data: any, code: string = null) {
        if (code === 'CRFROMQUOTE' || code === "CRFROMDISPATCH" || code === "CRFROMPARTS" || code === "CRFROMJOB") {
            this.saveMode = SaveMode.all;
            let dqoiParam: DQOIParam = data as DQOIParam;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.orderAdded = true;

            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);
            let info: OrderMessageInfo = dqoiParam.data as OrderMessageInfo;
            this.clear();
            this.setData(info.orderBus);
            this.isSubPO = this.data.isSub;
            //            this.getData();
            this.customerChanged(this.data.customerId);
            this.locationChanged(this.data.locationId);
            this.editForm.patchValue({
                locationId: this.data.locationId
            });

            this.addtlData = new AdditionalOrderData(info.dcValues.addtlData);
            this.pageData = new OrderPage(this.svc_data);
            //            this.pageData.setEquipment(info.dcValues.equipment);
            this.setFormAddtl();
            this.edit();
            this.setDirty();

        }
        else if (code === "GOTO") {
            this.clear();
            this.checkChange(this.dqoiIndex, SearchTarget.order, false);
            this.getDataFromId(data.id);
        }
    }
    canSaveChildren(): BaseMessageInfo {
        let msgInfo = super.canSaveChildren();
        if (this.lineItemsComp.isEditing && !this.lineItemsComp.canSaveForm) {
            let msg: MessageInfo = this.lineItemsComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        return msgInfo;
    }
    saveNotes() {
        var busObj =
        {
            orderId: this.id,
            notes: this.editForm.controls["notes"].value
        }
        this.mainLoadingOn(true, this.compLoader);
        this.subs_save = this.svc_data.saveNote(busObj).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                this.compLoader.cpLoaderOff();
                this.mainLoadingOff(true, this.compLoader);
                let not: string = "Note Successfully Saved";
                this.globals.notifySuccess(not);
            }
            else {
                this.saveError(info.message);
            }
            this.mainLoadingOff(true, this.compLoader);
        });

    }
    get canEditChild_Notes(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && ((this.canSave && this.saveMode === SaveMode.all) || this.hasId));
    }
    saveAll() {
        let busSaveObj: OrderBus = this.setForSave();
        let busObj: OrderSaveParam = new OrderSaveParam(busSaveObj);

        busObj.orderDetails = _.cloneDeep(this.lineItemsComp.getChanged());
        busObj.addDeletedItems(this.lineItemsComp.getDeletedItems());

        //validate lineitems for zuggit to cp orders - if we're about to create the order on the CP side,
        //make sure the lineitems won't exceed the CP max cost
        if(this.data.customerId === CommonValues.CustomerId_ClimateProsLLC && this.compFeatureFlagSet.featureFlagSet["ui-enable-zg-order-maxcost-validation"] &&
            (this.data.orderStatusId === CommonValues.Order_Fully_Received || this.data.orderStatusId === CommonValues.Order_Ordered)) {
                for (let line of this.addtlData.lineItems) {
                    if(line.price && line.invoiceMarkUp) {
                        let cpCost = line.price * (1  + (line.invoiceMarkUp ?? 0));

                        if(line.maxCost && cpCost > line.maxCost) {
                            this.globals.notifyError("The projected cost of $" + cpCost.toFixed(2) + " for item " + line.inventoryNumber + " exceeds the maximum allowed cost for Climate Pros of $" + line.maxCost.toFixed(2) + ".", true);
                            this.compLoader.cpLoaderOff();
                            return;
                        }
                    }
                }
        }

        if (CommonFunctions.hasValue(this.attachmentsComp)) {
            busObj.attachments = _.cloneDeep(this.attachmentsComp.getChanged());
            busObj.addDeletedItems(this.attachmentsComp.getDeletedItems());
        }
        if (CommonFunctions.hasValue(this.errorsComp)) {
            busObj.errors = _.cloneDeep(this.errorsComp.getChanged());
            busObj.addDeletedItems(this.errorsComp.getDeletedItems());
        }

        if (CommonFunctions.hasValue(this.orderNotesComp)) {
            busObj.orderNotes = _.cloneDeep(this.orderNotesComp.getChanged());
            busObj.addDeletedItems(this.orderNotesComp.getDeletedItems());
        }

        busObj.isConstruction = this.isConstruction == null ? true : this.isConstruction;

        CommonFunctions.unsubscribe(this.subs_save);
        this.mainLoadingOn(true, this.compLoader);
        this.subs_save = this.svc_data.saveAll(busObj).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                this.clear();
                this.getDataFromId(info.orderBus.orderId);
                this.saveSuccess();
                this.getListFromMaster(true);
                if (this.isConstruction) {
                }
                if (CommonFunctions.hasValue(this.attachmentsComp)) {
                    this.attachmentsComp.clearDeleted();

                }
            }
            else {
                this.saveError(info.message);
            }
            this.mainLoadingOff(true, this.compLoader);
        });
    }
    refresh() {

        //this.mainTab
        let tempId = this.id;
        this.id = undefined;
        this.cd.detectChanges();
        this.id = tempId;
        this.getDataFromId(this.id);
        this.getData();
        this.pageData.clear();
        this.refreshData(null);
        this.refreshToken = 0;
    }
    setMasterId() {
        if (!CommonFunctions.hasValue(this._masterId)) {
        }
    }
    protected setNoData(item: DQOIItem) {
        if (CommonFunctions.hasValue(item)) {
            this._masterId = item.dispatchId;
            this.getListFromMaster();
        }
    }
    setCustomerLocation(customerId: any, locationId: any) {
        this.data.customerId = customerId;
        this.data.locationId = locationId;
        super.setCustomerLocation(customerId, locationId);
    }
    rawMasterList: any[]; //MasterJobList[];

    filterMasterList(value) {
        if (!value) {
            return;
        }
        let list: any[] = this.masterListAll?.filter((s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1) ?? [];
        let grpmasterList: GroupResult[] = groupBy(list, [{ field: "supplierName" }])
        this.masterList = grpmasterList;
    }
    cloneMasterList() {
        this.masterListAll = _.cloneDeep(this.rawMasterList);
    }
    getListFromMaster(refresh: boolean = false) {

        if (refresh === true) {
            this.masterList = [];
        }
        if (CommonFunctions.hasArrayElementValue(this.masterList)) {
            return;
        }
        if (this.hasMasterId) {
            this.masterListLoader = true;
            CommonFunctions.unsubscribe(this.subs_masterList);
            this.subs_masterList = this.svc_data.getListFromMaster(this.masterId).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                for (let i = 0; i < info.dcValues.ML.length; i++) {
                    let busObj: DispatchOrder = new DispatchOrder(info.dcValues.ML[i]);
                    arr.push(busObj);
                }
                this.rawMasterList = arr;
                let grpmasterList: GroupResult[] = groupBy(this.rawMasterList, [{ field: "supplierName" }])
                this.masterList = grpmasterList;

                //this.masterList = info.primaryReturn;

                this.cloneMasterList();

                if (CommonFunctions.hasGuidValue(info.primaryId)) {
                    this._masterId = info.primaryId;
                }
                this.masterListLoader = false;
            });
        }
    }
    public iconClass: string = 'fa fa-plus';
    public orderTypeData: Array<any> = [
        {
            text: 'New Order',
            iconClass: 'fa fa-shopping-cart'
        }, {
            text: 'New Sub-PO',
            iconClass: 'fa fa-user'
        }];

    public onAddSplitButtonClick(e: string): void {
        if (e === "New Order") {
            this.isSubPO = false;
        }
        else {
            this.isSubPO = true;
        }
        this.new();
        this.lineItemsComp.clearAggrigates();
    }
    clearChildren() {
        if (CommonFunctions.hasValue(this.attachmentsComp)) {
            this.attachmentsComp.clear();
        }
        if (CommonFunctions.hasValue(this.errorsComp)) {
            this.errorsComp.clear();
        }
        if (CommonFunctions.hasValue(this.lineItemsComp)) {
            this.lineItemsComp.clear();
        }
        if (CommonFunctions.hasValue(this.supplierInfoComp)) {
            this.supplierInfoComp.clear();
        }
        if (CommonFunctions.hasValue(this.orderNotesComp)) {
            this.orderNotesComp.clear();
        }

    }
    clear() {
        super.clear();
        if (this.searchOperatingMode == SearchOperatingMode.Multiple) {
            this.lineItemsComp.resetDefaultValues();
            this.common = new CommonParam;
        }
    }
    subpoOrderInfoChanged(data: SubPOOrderInfo) {

    }
    test() {
        console.log("ord-test:", this, this.isSubPO);
    }
    override parentMessage(e: Message, cpLoader: ICPLoader): void {
        if (e.messageType === MessageType.aggregateResultsUpdated) {
            this.editForm.patchValue({
                remBlanketAmount: this.editForm.value.blanketAmount + this.editForm.value.chgOrdBlanketAmount - e.value.amount.sum
            });
            return;
        }
        super.parentMessage(e, cpLoader);
    }

    blanketAmountChange(value: any) {
        if (this.editForm.value.blanketAmount < 1) {
            this.errorMsg = "Value must be greater than 1.00";
        }
        this.editForm.patchValue({
            remBudget: this.editForm.value.blanketAmount - this.addtlData.amountDue
        });
    }
    supplierChanged(data: v_SupplierLocationBus) {
        let supplierId: any = null;
        let supplierLocationId: any = null;
        let termId: any = null;
        let markUp: any = null;
        let margin: any = null;

        if (CommonFunctions.hasValue(data)) {
            supplierId = data.supplierId;
            supplierLocationId = data.supplierLocationId;
            termId = data.termId;
            markUp = data.markUp;
            margin = data.margin;
        }
        this.editForm.patchValue({
            supplierId: supplierId,
            supplierLocationId: supplierLocationId,
            termId: termId,
            margin: margin
        });
        this.markUp = markUp;
        this.margin = margin;
        if (this.lineItemsComp) {
            this.lineItemsComp.invSupplierhanged(supplierId);
        }
    }
    markUp: number;
    margin: number;
    override trySave() {
        const limit = this.globals.user?.poApprLimit ?? 0
        if (this.lineItemsComp.getTotalAmount() > limit) {
            let not: string = "You have exceeded your spending limit of $" + limit;
            this.globals.notifyError(not, true);
        } else {
            super.trySave(this.compLoader);
        }
    }

    setFormSubPOValidation() {
        const shippingMethodId = this.editForm.get('shippingMethodId');
        const projMgrPersonId = this.editForm.get('projMgrPersonId');
        const validatorsOff = [];
        const validatorsOn = [Validators.required];
        if (this.isSubPO) {
            shippingMethodId.setValidators(validatorsOff);
        } else {
            shippingMethodId.setValidators(validatorsOn);
            projMgrPersonId.setValidators(validatorsOff);
        }
        if (this.isSubPO && this.isConstruction) {
            projMgrPersonId.setValidators(validatorsOn);
        }
    }

    setCustomerDataFromLineItem(event: any) {
        this.customerChanged(event.CustomerId);
        //this.data.customerId = event.CustomerId;
        this.locationChanged(event.LocationId);
    }

    handleError(error) {
        this.mainLoadingOff(true, this.compLoader);
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this.notifyError(errorMessage);
    }
}